import { FC } from 'react';
import { useAppDrawer } from '../AppDrawer/AppDrawerProvider';
import LogsLayout from './LogsLayout';
import { useLocation } from 'react-router-dom';
import { usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import useFeature from '../SystemSettings/hooks/featureFlags/useFeature';

const ContextWrapper = (props) => {
    const drawerContext = useAppDrawer();
    const location = useLocation();
    const { pricingModulesState } = usePricingModulesState();
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);

    return (
        <LogsLayout
            {...props}
            appDrawerContext={drawerContext}
            systemMode={systemMode}
            pricingModulesState={pricingModulesState}
            location={location}
        />
    );
};

const LogsWithContext: FC = ContextWrapper;

export default LogsWithContext;
